module.exports = __webpack_public_path__ + "img/train_person.ea83c0f0.svg";